var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkflowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4C4.44036 4 5 3.44036 5 2.75C5 2.05964 4.44036 1.5 3.75 1.5C3.05964 1.5 2.5 2.05964 2.5 2.75C2.5 3.44036 3.05964 4 3.75 4ZM6.39648 3.5C6.07002 4.65425 5.00878 5.5 3.75 5.5C2.23122 5.5 1 4.26878 1 2.75C1 1.23122 2.23122 0 3.75 0C5.00878 0 6.07002 0.845748 6.39648 2H11.625C13.489 2 15 3.51104 15 5.375C15 7.1994 13.5524 8.68569 11.7432 8.74797L8.43594 11.1103C8.17516 11.2966 7.82485 11.2966 7.56408 11.1103L4.26416 8.75322C3.28022 8.81058 2.5 9.62668 2.5 10.625C2.5 11.6605 3.33947 12.5 4.375 12.5H9.60352C9.92998 11.3457 10.9912 10.5 12.25 10.5C13.7688 10.5 15 11.7312 15 13.25C15 14.7688 13.7688 16 12.25 16C10.9912 16 9.92998 15.1543 9.60352 14H4.375C2.51104 14 1 12.489 1 10.625C1 8.8006 2.44758 7.3143 4.25681 7.25203L7.56408 4.88969C7.82485 4.70343 8.17516 4.70343 8.43594 4.88969L11.7359 7.24678C12.7198 7.18941 13.5 6.37332 13.5 5.375C13.5 4.33947 12.6605 3.5 11.625 3.5H6.39648ZM13.5 13.25C13.5 13.9404 12.9404 14.5 12.25 14.5C11.5596 14.5 11 13.9404 11 13.25C11 12.5596 11.5596 12 12.25 12C12.9404 12 13.5 12.5596 13.5 13.25ZM8.00001 6.42167L5.79035 8L8.00001 9.57833L10.2097 8L8.00001 6.42167Z",
    fill: "#5D7283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowsIcon);
export default __webpack_public_path__ + "static/media/WorkflowsIcon.297f71c03c249a028a723d29a8849cf4.svg";
export { ForwardRef as ReactComponent };